<template>
  <div>
    <Row :gutter="12">
      <sl-label title="选择商品">
        <Row :gutter="12">
          <Col span="12" class="margin-bottom">
            <sl-select :data="products" placeholder="选择商品" :filterable="true" @on-change="handleChange" :full-props="true"></sl-select>
          </Col>
          <Col span="6" class="margin-bottom">
            <Button @click="handleAdd()">添加</Button>
          </Col>
        </Row>
      </sl-label>
    </Row>  
    
    <sl-table ref="table" :enable-pager="false" :columns="columns" :data="goods"></sl-table>

    <div class="center margin-top">
      <Button @click="reset">重置</Button>
      <Button :loading="loading" @click="save" type="primary">确定</Button>
    </div>
  </div>

</template>
<script>
const createProducts = (specs)=>{
  return []
}
export default {
  data() {
    return {
      columns:[
        {
          title:'商品名称',
          key:'name',
        },
        {
          title: '商品数量',
          key: 'goodsNum',
          render: (h, params) => {
            return h('InputNumber', {
                props: {
                  value: params.row.goodsNum,
                  min: 1,
                  step:1
                },
                on: {
                  input: (v) => {
                    this.setGoodsNum(params.row.id , v)
                  }
                }
              })
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          render: (h, params) => {
          
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.remove(params)
                  }
                }
              }, '删除')
            ])
          }
        },
      ],
      data:{},
      products:[],
      goods:[],
      specs:[],
      loading:false
    }
  },

  props:{
    orderId:{

    }
  },
  watch:{
    orderId(val){
      if(val){
        this.query()
      }
    }
  },

  mounted() {},

  methods: {
    init(id) {
      this.orderId = id
    },

    query(){
      
      this.$request.orderGoodsQuery(this.orderId).then(resp => {
        if(!resp.code){
          this.def = resp.data

          this.$utils.fill(this.form , this.def)

          this.goods = (resp.data || []).map(i=>({id:i.skuId , name:i.skuName , goodsNum:i.goodsNum }))

          let opts = {pageSize:9999}
          // if( this.goods.length && this.goods[0].isStages ){
          //   opts['isStages'] = 1
          // }
          
          this.$request.skus(opts).then(resp => {
            this.products = (resp.data.list || []).map(i=>({value:i.id , label :i.name , raw : i}))
          })

        }else{
          this.$Message.error({content:resp.message})
        }
      })
    },

    save() {
      let params = { info:{ id:this.orderId } , goods:this.goods.map(i=>({skuId:i.id , goodsNum:i.goodsNum}))}

      this.loading = true
      this.$request.orderGoodsUpdate(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
        }
        this.loading = false
      })

    },
    reset(){
      this.goods = (this.def || []).map(i=>({id:i.skuId , name:i.skuName , goodsNum:i.goodsNum}))

    },

    remove({row}){
      let index = this.find(row.id)
      if(index >= 0){
        this.goods.splice(index , 1)
      }
    },

    find(id){
      return this.goods.findIndex( i=> (i.id == id))
    },


    setGoodsNum(id , count){
      let index = this.find(id)
      if(index>=0){
        this.goods[index].goodsNum = count
      }
    },

    handleAdd(){
      if( this.data ){
        let index = this.find(this.data.id)
        if(index == -1){
          this.goods.push({
            name:this.data.name,
            goodsNum:1,
            id:this.data.id
          })
        }else{
          this.$Notice.warning({
            title: '添加失败',
            desc: '当前商品已存在'
          })
        }

      }
    },

    handleChange(v){
      this.data = v.raw
    }
  }
}
</script>